import { findObjectByProperty, getValuesByPropertyPath } from "./dataUtils";
import { Session } from "./sessionUtils";

/**
 * Normalizes or processes an Auction Package object returned from the backend.
 * This is similar to prepareBaselineObject in baselineUtils.js.
 *
 * @param {object} aucPkg - The raw auction package object from the backend.
 * @returns {object} - The normalized auction object, ready for use in the UI.
 */
// export function prepareAuctionPackageObject(aucPkg, allUsers) {
export function prepareAuctionPackageObject(aucPkg) {
	if (!aucPkg || typeof aucPkg !== "object") return {};

	const aucItemSelected = getValuesByPropertyPath(aucPkg.auc_package_items, "baseline_item_id");
	const aucBidderSelected = getValuesByPropertyPath(aucPkg.auc_package_bidders, "user_id");
	const packageItems = Array.isArray(aucPkg.auc_package_items) ? aucPkg.auc_package_items : [];
	// Recompute bidder balance from the live package-item winners so the package
	// table and item detail stay aligned even when older fund_available values
	// arrive stale from previously fetched bidder records.
	const normalizedBidders = (Array.isArray(aucPkg.auc_package_bidders) ? aucPkg.auc_package_bidders : []).map(
		(bidder) => {
			const fundAssigned = Number(bidder?.fund ?? 0);
			const committedAmount = packageItems.reduce((sum, item) => {
				if (Number(item?.highest_bidder_id) !== Number(bidder?.user_id)) {
					return sum;
				}
				return sum + Number(item?.current_price ?? 0);
			}, 0);

			return {
				...bidder,
				fund_available: fundAssigned - committedAmount,
			};
		}
	);
	const myBidderInfo = findObjectByProperty(normalizedBidders, "user_id", Session().currUser.id);

	return {
		...aucPkg,
		auc_package_bidders: normalizedBidders,
		aucItemSelected: aucItemSelected,
		aucBidderSelected: aucBidderSelected,
		myBidderInfo: myBidderInfo,
		statusLabel: aucPkg.status_id === 1 ? "Active" : aucPkg.status_id === 0 ? "Archived" : "Unknown",
	};
}

export function prepareAuctionPackageItemObject(aucPkg, aucPkgItem) {
	if (!aucPkgItem || typeof aucPkgItem !== "object") return {};

	const myAutoBids = aucPkgItem?.auc_auto_bids?.filter((x) => x.user_id === Session().currUser.id);

	return {
		...aucPkgItem,
		myAutoBids: myAutoBids,
		myBidderInfo: aucPkg.myBidderInfo,
	};
}
